var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCloseBig = function SvgCloseBig(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_655_3779)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1854 5.87143L12 11.0569L6.81454 5.87143C6.68952 5.74641 6.51995 5.67617 6.34314 5.67617C6.16633 5.67617 5.99676 5.74641 5.87173 5.87143C5.74671 5.99646 5.67647 6.16603 5.67647 6.34284C5.67647 6.51965 5.74671 6.68922 5.87173 6.81424L11.0572 11.9997L5.87173 17.1851C5.74671 17.3102 5.67647 17.4797 5.67647 17.6565C5.67647 17.8334 5.74671 18.0029 5.87173 18.1279C5.93067 18.1915 6.00256 18.2418 6.08255 18.2752C6.16253 18.3087 6.24877 18.3246 6.33543 18.3219C6.42209 18.3193 6.50718 18.298 6.58494 18.2597C6.66271 18.2213 6.73136 18.1668 6.78626 18.0997L11.9717 12.9142L17.1854 18.1279C17.3105 18.253 17.48 18.3232 17.6568 18.3232C17.8337 18.3232 18.0032 18.253 18.1282 18.1279C18.2533 18.0029 18.3235 17.8334 18.3235 17.6565C18.3235 17.4797 18.2533 17.3102 18.1282 17.1851L12.9428 11.9997L18.1282 6.81424C18.2533 6.68922 18.3235 6.51965 18.3235 6.34284C18.3235 6.16602 18.2533 5.99646 18.1282 5.87143C18.0032 5.74641 17.8337 5.67617 17.6568 5.67617C17.48 5.67617 17.3105 5.74641 17.1854 5.87143Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_655_3779"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCloseBig, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close-big.32da66b2.svg";
export { ForwardRef as ReactComponent };